import { ServiceKind } from "@bitory-gmbh/bsm";
import { NavLink } from "react-router";
import { useDocumentPath } from "@/services/backend/documents/components/use-document-path";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { Button } from "@/shared/components/ui/button";
import { DocumentReferenceNumberById } from "@/services/backend/documents/components/document-reference-number-by-id";

export function DocumentLink({
  documentId,
  documentKind,
  serviceKind,
  processId,
}: {
  documentId: string;
  documentKind: string;
  serviceKind: ServiceKind;
  processId: string;
}) {
  const { path } = useDocumentPath({
    documentId,
    documentKind,
    serviceKind: serviceKind as GSMServiceKind,
    processId,
  });

  return (
    <Button asChild variant="link" size="sm" className="whitespace-normal">
      {path ? (
        <NavLink to={path!}>
          <DocumentReferenceNumberById
            serviceKind={serviceKind}
            documentKind={documentKind}
            documentId={documentId}
          />
        </NavLink>
      ) : (
        <DocumentReferenceNumberById
          serviceKind={serviceKind}
          documentKind={documentKind}
          documentId={documentId}
        />
      )}
    </Button>
  );
}
